var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXcrossIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.662 17.96 13.702 12l5.96-5.96c.45-.45.45-1.251 0-1.702-.45-.45-1.252-.45-1.703 0L12 10.298l-5.96-5.96c-.45-.45-1.251-.45-1.702 0-.45.45-.45 1.252 0 1.703L10.298 12l-5.96 5.96c-.45.45-.45 1.251 0 1.702.45.45 1.252.45 1.703 0L12 13.702l5.96 5.96c.45.45 1.251.45 1.702 0 .45-.45.45-1.252 0-1.703Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgXcrossIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/xcross-icon.3d32586b0852300064161d63105c6dd0.svg";